// extracted by mini-css-extract-plugin
module.exports = {"gridGapSize":"18","gridGapSizeMobile":"10","specialGroupBoderWidth":"2","slotBaseHeight":"258","slotBaseWidth":"184"};